export default __webpack_public_path__ + "static/media/consulting.d195f187.jpg";